import { getISOWeek } from "date-fns";
import { getDeviceType } from "@/helpers/storeLocatorHelper";
import { Tour } from "nextstepjs";
const deviceType = getDeviceType();
const weekNumber = getISOWeek(new Date());
//gettting current week to show pop up in mobile device

const mealPlanGuide: Tour[] = [
  {
    tour: "mealPlanTour",
    steps: [
      {
        icon: "",
        title: "",
        content: "Click here to schedule a meal for the day.",
        selector: `#Add_meal_plan_button_1-${weekNumber}`,
        side:
          deviceType === "mobile" || deviceType === "tablet"
            ? "top-right"
            : "top-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content: "Want a copy? Click here to print your meal plan.",
        selector: "#print_meal_plan",
        side: deviceType === "tablet" ? "top-right" : "top-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content: "Want to share? Send your meal plan by text or email.",
        selector: "#send_meal_plan_on_email",
        side: deviceType === "tablet" ? "top-right" : "top-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content:
          "Lastly, turn your meal plan into a shopping list for easy in-store shopping.",
        selector: "#add_meal_to_shopingList",
        side: deviceType === "tablet" ? "top-right" : "top",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default mealPlanGuide;
